export default "__VITE_ASSET__BphrAwVz__"